export const Endpoint = 'chat/focus-monitoring/set-is-looking-at-chat';
export const Method = 'POST';
